import { FunctionComponent } from "react";

import { Typography } from "@digital-services/ui";

const Title: FunctionComponent = () => {
  return (
    <div
      className="w-full pl-[40px] text-center sm:pl-[150px]"
      data-testid="header-title"
    >
      <Typography variant="pageTitle">ABB E-mobility Admin Portal</Typography>
    </div>
  );
};

export default Title;
